import Block from '../../common.blocks/block'

export default class CheckoutTotal extends Block {
	static title = 'checkout-total'

	constructor($el) {
		super($el)

		this.button = this.$el.find('.checkout__button--parcelshop')

		if (this.button) {
			this.setState()

			$(document).on('total:next', () => {
				this.setState()
			})
		}
	}

	setState() {
		const parcelshop = $('.parcelshop__select')
		const parcelshopCode = $('.parcelshop__customerid-input')

		let disabled = true

		if (parcelshop.val()) {
			disabled = false
		}

		if (parcelshopCode.is(':visible')) {
			if (parcelshopCode.val()) {
				disabled = false
			} else {
				disabled = true
			}
		}

		this.button.prop('disabled', disabled)
	}
}
